import React from 'react';
import { Box, Dialog, Drawer } from '@mui/material';

export default function ArticlePanel({ open, onClose, isMobile, children }) {
    if (isMobile) {
        return <Dialog open={open} onClose={onClose} fullScreen>{children}</Dialog>;
    }

    return (
        <Drawer anchor="right" open={open} onClose={onClose}
            PaperProps={{ sx: { width: 600, display: 'flex', flexDirection: 'column' } }}>
            <Box sx={{ flex: 1, overflowY: 'auto', p: 3, pb: 6 }}>
                {children}
            </Box>
        </Drawer>
    );
}
